import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LoadedContent from './LoadedContent';
import { connect } from 'react-redux';
import ProjectTextCard from './ProjectTextCard';
import ProjectImage from './ProjectImage';
import ProjectVideo from './ProjectVideo';
import { I18n } from 'react-redux-i18n';

export class ProjectPage extends Component {
  componentWillReceiveProps() {
    document.getElementById('base-page').scrollTop = 0;
  }

  render() {
    const { projectSelected, isFetching } = this.props;
    const subtitle = I18n.t('project_page.subtitle');

    if (isFetching) return null;

    return (
      <LoadedContent projectSelected={projectSelected}>
        <div id="project-page">
          <div id="project-header">
            <div className="subtitle">
              {subtitle}
            </div>
            <div id="project-name" className="page-title">
              {projectSelected.name}
            </div>
          </div>

          <div id="project-details">
            {projectSelected.details.map((detail, index) => {
              switch (detail.type) {
                case 'card':
                  return <ProjectTextCard key={index} body={detail.body} />;

                case 'image':
                  return <ProjectImage key={index} value={detail.value} />;

                case 'video':
                  return <ProjectVideo key={index} value={detail.value} />;
                default:
                  return;
              }
            })}
          </div>
        </div>
      </LoadedContent>
    );
  }
}

ProjectPage.propTypes = {
  selectProject: PropTypes.func,
  projectSelected: PropTypes.object,
  params: PropTypes.object,
  isFetching: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => {
  const isFetching = state.projects.isFetching;
  const slug = ownProps.params.slug;
  return {
    isFetching,
    projectSelected: isFetching ? null : state.projects.data[slug]
  };
};

const ProjectPageContainer = connect(mapStateToProps)(ProjectPage);
export default ProjectPageContainer;



// WEBPACK FOOTER //
// ./src/components/ProjectPage.js